import React, { useEffect, useState } from "react";
import "./HeroSection.scss";
import LazyImage from "../LazyImage/LazyImage";

export default function HeroSection({
  title,
  subTitle,
  description,
  images = [],
}) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
      }, 8000);
      return () => clearInterval(interval);
    }
  }, [images]);
  return (
    <div className="hero-section">
      {images.length > 0 && (
        <div className="hero-section__slider">
          {images.map((image, index) => (
            <LazyImage
              key={index}
              alt={`Slide ${index}`}
              className={`hero-section__image ${
                index === currentSlide ? "active" : ""
              }`}
              src={image}
            />
          ))}
          <div className="overlay"></div>
        </div>
      )}

      <div className="hero-section__content">
        <h1 className="title">{title}</h1>
        <div className="line"></div>
        {subTitle && <h2 className="sub-title">{subTitle}</h2>}
        {description && <p className="description">{description}</p>}
      </div>
    </div>
  );
}
